<template>
  <sc-modal :active="isActive" @close="closeCallback" :can-cancel="false" :destroy-on-hide="true">
    <sc-modal-card title="Incluir CNPJ">
      <template slot="body">
        <section class="spinner-section" v-if="isLoading">
          <sc-spinner />
          <p>Aguarde enquanto processamos seu certificado digital</p>
        </section>
        <section class="content-section" v-else>
          <p>Depois de adicionar o certificado digital, aguarde aproximadamente 1 hora para conseguir visualizar os CT-es no TMS.</p>
          <section class="sefaz-warning">
            <div class="warning-icon">
              <i class="fas fa-info-circle"></i>
            </div>
            <div>
              <strong>Importante: </strong>
              Buscaremos na SEFAZ apenas os CT-es emitidos após a inclusão do certificado digital.
            </div>
          </section>
          <section class="upload-steps">
            <sc-field prop="certificateFile">
                <template slot="label">
                  <sc-tag size="is-medium" rounded>1</sc-tag>
                  Adicionar certificado
                </template>
                <sc-files-upload
                  ref="ctesFilesUpload"
                  v-bind="fileImporterOptions"
                  @addfilestart="(file) => (uploadForm.certificateFile = file)"
                  @removefile="() => (uploadForm.certificateFile = null)"/>
            </sc-field>

            <sc-field prop="certificatePassword">
              <template slot="label">
                <sc-tag size="is-medium" rounded>2</sc-tag>
                Inserir senha
              </template>
              <sc-input
                v-model="uploadForm.certificatePassword"
                type="password"
                autocomplete="off"
              />
            </sc-field>
          </section>
        </section>
      </template>
      <template slot="footer">
        <sc-button
          theme="default"
          text="Voltar"
          :inverted="true"
          :disabled="isLoading"
          @click="() => closeCallback()"
        />
        <sc-button
          type="submit"
          theme="primary"
          text="Adicionar certificado"
          :disabled="isLoading || !isFormComplete"
          @click="() => finishCallback(uploadForm)"
        />
      </template>
    </sc-modal-card>
  </sc-modal>
</template>
<script>
  import {
    ScModal,
    ScModalCard,
    ScSpinner,
    ScTag,
    ScForm,
    ScField,
    ScFilesUpload,
    ScInput,
    ScButton,
  } from '@intelipost-js/secure-components';

  export default {
    name: 'ScAddCertificateModal',
    data() {
      return {
        uploadForm: {
          certificateFile: undefined,
          certificatePassword: undefined,
        },
      };
    },
    computed: {
      fileImporterOptions() {
        return {
          labelIdle: 'Arraste um arquivo ou <strong>clique aqui</strong> para buscar.',
          acceptedFileTypes: ['application/x-pkcs12', '.pfx'].join(','),
          allowMultiple: false,
        };
      },
      isFormComplete() {
        return this.uploadForm &&
          this.uploadForm.certificateFile &&
          this.uploadForm.certificatePassword;
      },
    },
    props: {
      isActive: {
        type: Boolean,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      closeCallback: {
        type: Function,
        required: true,
      },
      finishCallback: {
        type: Function,
        required: true,
      },
    },
    components: {
      ScModal,
      ScModalCard,
      ScSpinner,
      ScTag,
      ScForm,
      ScField,
      ScFilesUpload,
      ScInput,
      ScButton,
    },
  };
</script>
<style lang="scss">
  .spinner-section {
    display: flex;
    flex-direction: column;
    align-items: center;

    & p {
      margin-top: 1em;
    }
  }

  .sefaz-warning {
    margin-top: 10px;
    padding: 8px;

    display: flex;
    align-items: baseline;
    border-style: solid;
    border-width: 1px;
    border-radius: 8px;
    border-color: #3670D6;
  }

  .warning-icon {
    margin: 5px;
    color: #3670D6;
  }

  .upload-steps {
    margin-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/components/sc-add-certificate-modal/ScAddCertificateModal.vue?03266867